import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { reactive, ref, unref, onMounted } from 'vue';

/* Npm Plugins */
import { ElButton, ElTag, ElMessage, ElMessageBox } from 'element-plus';
import moment from 'moment';

/* Components */
import Writer from './components/Writer.vue';
import { GbTables } from '@/components/GbTables';

/* Hooks */
import { useGbTable } from '@/hooks/useGbTable';
import { useLocales } from '@/hooks/useLocales';

/* Apis */
import { GetCtTemplateListApi, GetCtTemplateDelApi, TempStatusChangeApi } from '../../../apis/ct_templates/templates.api';

/* Dtos */
import { CtTempListDto, CtTempSearchDto, CtTempDelDto } from '../../../apis/ct_templates/templates.dto';
import { FileDownloadApi, CheckMaterialApi } from '../../../apis/materials/material.api';
import { TableColumn } from '../../../components/GbTables/GbTablesTypes';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const writerRef = ref<ComponentRef<typeof Writer>>();

const { register, tableObject, methods } = useGbTable<CtTempListDto>({
	getListApi: GetCtTemplateListApi,
	delListApi: GetCtTemplateDelApi,
	response: { data: 'data', total: 'total' },
});

const { setSearchParams } = methods;

const search = reactive<CtTempSearchDto>({ current: 1, page_size: 10 });

// 获取多语言翻译函数
const { t } = useLocales();

const tabColumns = reactive<TableColumn[]>([
	{ field: 'code', label: t('templates.table.templateCode', '模板编号'), columnWidth: '150' },
	{ field: 'name', label: t('templates.table.templateName', '模板名称') },
	{ field: 'category_name', label: t('templates.table.contractCategory', '合同类别'), columnWidth: '150' },
	{ field: 'template_type', label: t('templates.table.templateType', '模板类别'), columnWidth: '100', align: 'center' },
	{ field: 'enabled_day', label: t('templates.table.enabledDate', '生效日期'), align: 'center', columnWidth: '100' },
	{ field: 'invalid_day', label: t('templates.table.invalidDate', '失效日期'), align: 'center', columnWidth: '100' },
	{ field: 'version', label: t('templates.table.version', '版本'), align: 'center', columnWidth: '60' },
	{ field: 'is_enabled', label: t('templates.table.enabledStatus', '启用状态'), align: 'center', columnWidth: '80' },

	{ field: 'company_name', label: t('templates.table.companyName', '所属公司'), columnWidth: '120', align: 'center' },
	{ field: 'create_user_name', label: t('templates.table.creator', '创建人'), columnWidth: '80', align: 'center', fixed: 'right' },
	{ field: 'created_time', label: t('templates.table.createdTime', '创建时间'), columnWidth: '120', align: 'center', fixed: 'right' },
	{ field: 'action', width: '120px', label: t('templates.table.action', '操作'), fixed: 'right', align: 'center' },
]);

/* 内部的方法 */
const actions = {
	/* 点击创建按钮 */
	onCreateBtnClick: () => {
		unref(writerRef)?.writerMethods.showDialog();
	},

	/* 点击修改按钮 */
	onEditBtnClick: (rowId: string) => {
		const writer = unref(writerRef);
		writer?.writerMethods.setCatetoryData(rowId);
	},

	/* 删除记录 */
	onDeleteBtnClick: async (row: CtTempListDto) => {
		const delData: CtTempDelDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(delData);
	},

	/* 下载文件 */
	onDownloadBtnClick: (fileId: string, name: string) => {
		if (!fileId) ElMessage.warning(t('templates.message.fileNotFound', '找不到文件'));
		/* 先检查文件 */
		CheckMaterialApi(fileId).then(async (res) => {
			if (!res.succeeded) {
				ElMessage.warning(`${t('templates.message.operationFailed', '操作失败，可能的原因是：')}${res.errors}`);
			} else {
				if (res.data == false) {
					ElMessage.error(t('templates.message.fileNotExists', '文件不存在'));
				} else {
					/* 调用下载接口 */
					const response = await FileDownloadApi(fileId);
					const downloadLink = document.createElement('a');

					downloadLink.href = window.URL.createObjectURL(response.data);
					downloadLink.download = name;
					downloadLink.click();
					window.URL.revokeObjectURL(downloadLink.href);
				}
			}
		});
	},

	/* 设置模板启用/停用状态 */
	onChangeStatue: (data: CtTempListDto) => {
		const statusText = data.is_enabled == 'Y' ? t('buttons.disabled', '停用') : t('buttons.enabled', '启用');
		ElMessageBox.confirm(
			t('templates.confirm.changeStatusMessage', '是否{status}选中的模板？').replace('{status}', statusText), 
			t('templates.confirm.changeStatusTitle', '提示'), 
			{ 
				lockScroll: false, 
				confirmButtonText: t('templates.confirm.confirmButtonText', '确定'), 
				cancelButtonText: t('templates.confirm.cancelButtonText', '取消'), 
				type: 'warning' 
			}
		).then(async () => {
			tableObject.loading = true;

			TempStatusChangeApi(data.id).then((res) => {
				if (!res.succeeded) ElMessage.warning(`${t('templates.message.operationFailed', '操作失败，可能的原因是：')}${res.errors}`);

				setSearchParams(search);
			});
		});
	},
};

onMounted(() => {
	setSearchParams(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(search),
          inline: true,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('templates.form.templateCode', '模板编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(search).code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).code) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('templates.form.templateName', '模板名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(search).name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(search).name) = $event)),
                  placeholder: "",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "primary",
            onClick: actions.onCreateBtnClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('templates.buttons.createTemplate', '创建模板')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          template_type: _withCtx(({ row }) => [
            (row.template_type == 'f62124f4-1a54-583c-d870-d07fd400d78b')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)('templates.table.documentTemplate', '文档模板')), 1))
              : _createCommentVNode("", true),
            (row.template_type == '1f2d36f9-b2e9-9b93-a86b-c454ea442934')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('templates.table.signTemplate', '签署模板')), 1))
              : _createCommentVNode("", true)
          ]),
          enabled_day: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.enabled_day).format('YYYY/MM/DD')), 1)
          ]),
          invalid_day: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.invalid_day).format('YYYY/MM/DD')), 1)
          ]),
          version: _withCtx(({ row }) => [
            _createElementVNode("span", null, "ver " + _toDisplayString(row.version) + ".0", 1)
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          is_enabled: _withCtx(({ row }) => [
            _createVNode(_unref(ElTag), {
              size: "small",
              type: row.is_enabled == 'Y' ? 'success' : 'danger'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.is_enabled == 'Y' ? _unref(t)('status.enabled', '启用') : _unref(t)('status.diabled', '停用')), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ElButton), {
                size: "small",
                type: "primary",
                link: "",
                onClick: ($event: any) => (actions.onEditBtnClick(row.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('templates.buttons.edit', '编 辑')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                size: "small",
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (row.can_download)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElButton), {
                                size: "small",
                                type: "info",
                                link: "",
                                onClick: ($event: any) => (actions.onDownloadBtnClick(row.material?.id, row.material?.file_name))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('templates.buttons.download', '文件下载')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "info",
                            link: "",
                            onClick: ($event: any) => (actions.onChangeStatue(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.is_enabled == 'Y' ? _unref(t)('templates.buttons.disable', '停 用') : _unref(t)('templates.buttons.enable', '启 用')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (actions.onDeleteBtnClick(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('templates.buttons.delete', '删 除')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(Writer, {
      ref_key: "writerRef",
      ref: writerRef,
      onOnSuccess: _cache[7] || (_cache[7] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
    }, null, 512)
  ], 64))
}
}

})